<app-side-menu>
  <div class="b2b-ops-page">
    <div class="page-header">
      <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
        <div>
          <button type="button" class="btn-back" (click)="navigateBack()"><i class="fas fa-arrow-left"></i></button>
          <h1 class="page-title"><i class="fas fa-exchange-alt me-2"></i>Substituições</h1>
          <p class="page-subtitle" *ngIf="contractNumber">Contrato: {{ contractNumber }} — {{ contractName }}</p>
        </div>
        <app-button
          *appHasPermission="'B2BContracts.Edit'"
          text="Nova substituição"
          color="var(--success-color)"
          height="40px"
          (buttonClick)="openCreate()">
          <i class="fas fa-plus me-2"></i>
        </app-button>
      </div>
    </div>

    <app-b2b-operational-nav *ngIf="contractId" [contractId]="contractId" active="substituicoes"></app-b2b-operational-nav>

    <div class="b2b-ops-card">

      <div *ngIf="!isLoading && items.length === 0" class="b2b-ops-empty">
        <i class="fas fa-exchange-alt"></i>
        <h3>Nenhuma substituição cadastrada</h3>
      </div>

      <app-table
        *ngIf="isLoading || items.length > 0"
        [title]="'Substituições (' + items.length + ')'"
        [data]="items"
        [columns]="columns"
        [actions]="actions"
        [loading]="isLoading"
        [showSearch]="true"
        (actionClick)="onActionClick($event)">
        <app-button
          table-header-action
          text="Exportar Excel"
          color="var(--success-color)"
          height="36px"
          [disabled]="items.length === 0"
          (buttonClick)="exportExcel()">
          <i class="fas fa-file-excel me-2"></i>
        </app-button>
      </app-table>
    </div>
  </div>

  <app-modal [isOpen]="showModal" [title]="modalTitle" size="lg" (close)="closeModal()">
    <form [formGroup]="form" class="b2b-ops-form-grid">
      <div class="form-group">
        <label class="form-label">Placa antiga</label>
        <app-b2b-contract-plate-select
          [contractId]="contractId"
          formControlName="oldPlate"
          (plateSelected)="onOldPlateSelected($event)">
        </app-b2b-contract-plate-select>
      </div>
      <div class="form-group">
        <label class="form-label">Placa nova</label>
        <app-b2b-contract-plate-select
          [contractId]="contractId"
          formControlName="newPlate"
          (plateSelected)="onNewPlateSelected($event)">
        </app-b2b-contract-plate-select>
      </div>
      <div class="form-group">
        <label class="form-label">Data da substituição</label>
        <input type="date" class="form-control" formControlName="substitutedAt">
      </div>
      <div class="form-group full">
        <label class="form-label">Observações</label>
        <textarea class="form-control" rows="2" formControlName="notes"></textarea>
      </div>
    </form>
    <div slot="footer" class="b2b-ops-modal-footer d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-secondary" (click)="closeModal()" [disabled]="submitting">
        {{ viewMode ? 'Fechar' : 'Cancelar' }}
      </button>
      <button *ngIf="!viewMode" type="button" class="btn btn-primary" (click)="submit()" [disabled]="submitting">
        {{ editingId ? 'Salvar' : 'Criar' }}
      </button>
    </div>
  </app-modal>
</app-side-menu>
